import React, { useEffect, useRef, RefObject } from 'react';
import { ToastNotification } from 'carbon-components-react';

type ExtendedToastProps = {
  buttonText: string;
  onButtonClick: () => void;
  onClose?: () => void;
} & React.ComponentProps<typeof ToastNotification>;

const ExtendedToastNotification: React.FC<ExtendedToastProps> = ({
  buttonText,
  onButtonClick,
  onClose,
  children,
  ...toastProps
}) => {
  const toastRef: RefObject<HTMLDivElement> = useRef(null);

  useEffect(() => {
    const closeButton = toastRef.current?.querySelector(
      '.bx--toast-notification__close-button'
    );

    if (closeButton && onClose) {
      closeButton.addEventListener('click', onClose);
      return () => {
        closeButton.removeEventListener('click', onClose);
      };
    }
  }, [onClose]);

  return (
    <div className="extended-toast-wrapper" ref={toastRef}>
      <ToastNotification {...toastProps}>
        {children}
        <button onClick={onButtonClick} className="extended-toast-button">
          {buttonText}
        </button>
      </ToastNotification>
    </div>
  );
};

export default ExtendedToastNotification;
